import { Component, OnInit, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";

import { UserService, AlertService } from "../_services";
import { AppGlobals } from "../app.globals";
import { matchValidator } from "../_helpers/forms/match.validator";

@Component({
    templateUrl: "changePasswordDialog.component.html",
    styleUrls: ["changePasswordDialog.component.css"]
})
export class ChangePasswordDialogComponent implements OnInit {
    changePasswordForm: UntypedFormGroup;
    hide = true;
    newHide = true;
    hideConfirm = true;
    studentRegistrationId: number;

    constructor(private dialogRef: MatDialogRef<ChangePasswordDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any, private formBuilder: UntypedFormBuilder, private userService: UserService, private alertService: AlertService, private appGlobals: AppGlobals) {
        this.studentRegistrationId = data.studentRegistrationId;
    }

    ngOnInit() {
        //this.googleAnalyticsService.logPageView("/changePassword");

        this.changePasswordForm = this.formBuilder.group({
            password: ["", [Validators.required, Validators.minLength(8)]],
            newPassword: ["", [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/), matchValidator("password", false)]],
            confirmPassword: ["", [Validators.required, Validators.minLength(8), matchValidator("newPassword", true)]]
        });
    }

    get f() {
        return this.changePasswordForm.controls;
    }

    save(submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.changePasswordForm.invalid) {
            return;
        }

        setTimeout(() => {
            submitBtn.disabled = true;
        }, 0);

        this.userService.changePassword(this.studentRegistrationId, this.f.password.value, this.f.newPassword.value, this.f.confirmPassword.value)
            .pipe(first())
            .subscribe(() => {
                this.alertService.showMessage("Password changed Successfully.", "Change Password", this.appGlobals.alertMessageTypes.success);
                this.dialogRef.close();
            });
    }

    close() {
        this.dialogRef.close();
    }
}
